function getPagePathBucket() {
    if (typeof window === 'undefined') return '';
    return window.location.pathname
        .replace(
            /\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi,
            '/:id',
        )
        .replace(/\/\d{2,}/g, '/:id');
}

function getDeviceType() {
    if (typeof window === 'undefined') return 'unknown';
    const ua = navigator.userAgent || '';
    if (/Mobi|Android|iPhone/i.test(ua)) return 'mobile';
    if (/Tablet|iPad/i.test(ua)) return 'tablet';
    return 'desktop';
}

function sendToGA(name, value, extra = {}) {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
        return;
    }
    window.gtag('event', name, {
        event_category: 'Web Vitals',
        value: Math.round(name === 'CLS' ? value * 1000 : value),
        metric_value: value,
        metric_id: extra.id,
        metric_rating: extra.rating,
        page_path: getPagePathBucket(),
        device: getDeviceType(),
        non_interaction: true,
    });
}

function rate(name, value) {
    if (name === 'LCP') return value <= 2500 ? 'good' : value <= 4000 ? 'ni' : 'poor';
    if (name === 'CLS') return value <= 0.1 ? 'good' : value <= 0.25 ? 'ni' : 'poor';
    if (name === 'INP') return value <= 200 ? 'good' : value <= 500 ? 'ni' : 'poor';
    if (name === 'FCP') return value <= 1800 ? 'good' : value <= 3000 ? 'ni' : 'poor';
    if (name === 'TTFB') return value <= 800 ? 'good' : value <= 1800 ? 'ni' : 'poor';
    return 'unknown';
}

function uid() {
    return `v${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
}

const observers = [];

function safeObserve(type, callback, options = {}) {
    if (typeof PerformanceObserver === 'undefined') return;
    if (!PerformanceObserver.supportedEntryTypes?.includes(type)) return;
    try {
        const po = new PerformanceObserver(callback);
        po.observe({ type, buffered: true, ...options });
        observers.push(po);
    } catch (err) {
    }
}

function onPageHidden(callback) {
    let fired = false;
    const handler = () => {
        if (fired) return;
        fired = true;
        callback();
    };
    window.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') handler();
    });
    window.addEventListener('pagehide', handler);
}

function trackLCP() {
    let lastValue = 0;
    const id = uid();
    safeObserve('largest-contentful-paint', (list) => {
        const entries = list.getEntries();
        const last = entries[entries.length - 1];
        if (last) lastValue = last.startTime;
    });
    onPageHidden(() => {
        if (lastValue > 0) {
            sendToGA('LCP', lastValue, { id, rating: rate('LCP', lastValue) });
        }
    });
}

function trackCLS() {
    let clsValue = 0;
    let sessionValue = 0;
    let sessionEntries = [];
    const id = uid();
    safeObserve('layout-shift', (list) => {
        for (const entry of list.getEntries()) {
            if (entry.hadRecentInput) continue;
            const firstEntry = sessionEntries[0];
            const lastEntry = sessionEntries[sessionEntries.length - 1];
            if (
                sessionEntries.length &&
                (entry.startTime - lastEntry.startTime > 1000
                    || entry.startTime - firstEntry.startTime > 5000)
            ) {
                sessionValue = 0;
                sessionEntries = [];
            }
            sessionValue += entry.value;
            sessionEntries.push(entry);
            if (sessionValue > clsValue) clsValue = sessionValue;
        }
    });
    onPageHidden(() => {
        sendToGA('CLS', clsValue, { id, rating: rate('CLS', clsValue) });
    });
}

function trackINP() {
    let worstDuration = 0;
    const id = uid();
    safeObserve(
        'event',
        (list) => {
            for (const entry of list.getEntries()) {
                if (entry.duration > worstDuration) worstDuration = entry.duration;
            }
        },
        { durationThreshold: 40 },
    );
    onPageHidden(() => {
        if (worstDuration > 0) {
            sendToGA('INP', worstDuration, { id, rating: rate('INP', worstDuration) });
        }
    });
}

function trackFCP() {
    const id = uid();
    safeObserve('paint', (list) => {
        for (const entry of list.getEntries()) {
            if (entry.name === 'first-contentful-paint') {
                sendToGA('FCP', entry.startTime, {
                    id,
                    rating: rate('FCP', entry.startTime),
                });
            }
        }
    });
}

function trackTTFB() {
    if (typeof performance === 'undefined') return;
    const nav = performance.getEntriesByType?.('navigation')?.[0];
    if (!nav) return;
    const ttfb = nav.responseStart - nav.startTime;
    if (ttfb > 0) {
        sendToGA('TTFB', ttfb, { id: uid(), rating: rate('TTFB', ttfb) });
    }
}

export function initWebVitals() {
    if (typeof window === 'undefined') return;
    try {
        trackLCP();
        trackCLS();
        trackINP();
        trackFCP();
        trackTTFB();
    } catch (err) {
        if (window.location?.hostname === 'localhost') {
            console.error('[webVitals]', err);
        }
    }
}
